import { type Manifest, type RouterConfig, PAGE_TYPE } from '@/types/manifest.ts';

const routerConfig: RouterConfig = {
    type: PAGE_TYPE.ENTRY,
    name: 'package',
    exclusiveRoutePath: '/package',
    getComponent: () => import('./PlgPackages.vue'),
};

export const manifest: Manifest = {
    ...routerConfig,
};

declare module '@patsnap/tahiti-core' {
    export interface CommandService {
        /**
         * 去到 Pricing Table 页面
         */
        executeCommand(commandId: 'command:route:package'): void;
    }
}
